import React from 'react';
import { AppointmentCTAProps } from 'util/Props';
import { appointmentCTA } from 'i18n/en.json';
import config from 'config';
import PDPInventoryMsg from './product/PDPInventoryMsg';
/*
    Display Schedule appointment CTA
    Destination url is constructed based on params
*/
class AppointmentCTA extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            quantity: props.qty || config.tiresSelectableQty.defaultQty || null,
            // isStaggered: props.isStaggered,
            qty2: props.isStaggered ? props.qty2 : null
        };
        this.clickHandler = this.clickHandler.bind(this);
        this.handleKeyPress = this.handleKeyPress.bind(this);
        this.handleQuantityChange = this.handleQuantityChange.bind(this);
        this.handleRearQuantityChange = this.handleRearQuantityChange.bind(this);
        this.getUrl = this.getUrl.bind(this);
    }

    // Building url query
    clickHandler(event) {
        event.preventDefault();
        const { storeId, userStore, postThisStore } = this.props;
        if (storeId !== userStore.id && postThisStore) {
            postThisStore();
        }
    }
    handleKeyPress(event) {
        if (event.charCode === 13) {
            this.clickHandler();
        }
    }
    handleQuantityChange(e) {
        this.setState({ quantity: e.target.value });
    }
    handleRearQuantityChange(e) {
        this.setState({ qty2: e.target.value });
    }
    getUrl() {
        const {
            storeId,
            userStore,
            categoryId,
            selectedCatID,
            pid,
            pid2,
            rearSize,
            isStaggered,
            frontSize,
            categoryUrl
        } = this.props;
        const {quantity, qty2} = this.state;
        let params = {};

        if (categoryUrl) {
            return categoryUrl;
        }

        if (userStore && userStore.id) {
            params.storeid = userStore.id;
        }
        if (storeId && storeId !== '') {
            params.storeid = storeId;
        }
        if (pid && pid !== '') {
            params.pid = pid;

            if (quantity) {
                params.qty = quantity;
            }
        }
        if (isStaggered) {
            if (pid2 && pid2 !== '') {
                params.pid2 = pid2;
            }
            // When both pids are present, qty2 is rear, qty is front
            if (qty2) {
                params.qty2 = qty2;
            }
            if (rearSize && rearSize !== '') {
                params.rearSize = rearSize;
                // Staggered logic for a missing tire - qid2 has quanitty for missing tire(front or rear)
                if (!pid2) {
                    params.qty = quantity;
                    params.qty2 = qty2;
                }
            }
            if (frontSize && frontSize !== '') {
                params.frontSize = frontSize;
                // Staggered logic for a missing tire - qid2 has quanitty for missing tire(front or rear)
                if (!pid2) {
                    params.qty = qty2;
                    params.qty2 = quantity;
                }
            }
        }

        if (categoryId) {
            params.categoryId = categoryId;
        }

        if (selectedCatID) {
            params.selectedCatID = selectedCatID;
        }

        let paramsArr = Object.keys(params);
        const redirectURL =
            this.props.ctaUrl +
            paramsArr.reduce(
                (acc, param, index) => `${acc}${param}=${params[param]}${index === paramsArr.length - 1 ? '' : '&'}`,
                this.props.ctaUrl.indexOf('?') > -1 ? '&' : '?'
            );

        return redirectURL;
    }
    render() {
        //Do not render CTA if user store is not enabled
        //Store detail pages can override user store flag through appointmentCTADisplayOverride - default value is null,
        //store can set it to reflect it's enableAppointment property
        if (this.props.appointmentCTADisplayOverride !== null) {
            if (this.props.appointmentCTADisplayOverride === false) {
                return null;
            }
        }
        if (
            !this.props.isShow &&
            (!this.props.userStore || !this.props.userStore.enableAppointment) &&
            this.props.appointmentCTADisplayOverride !== true
        ) {
            return null;
        }
        if (!this.props.ctaUrl || !this.props.ctaLabel) {
            return null;
        }
        return (
            <div
                className={
                    'appointmentCTA ' + (this.props.classes ? this.props.classes : '')
                }
            >
                {this.props.collectQuantity && (
                    <React.Fragment>
                        <div
                            className={
                                this.props.isStaggered
                                    ? 'quantity__select-container quantity__select-container--staggered'
                                    : 'quantity__select-container'
                            }
                        >
                            <div>
                                <label htmlFor="product-qty">
                                    <strong>
                                        {this.props.isStaggered
                                                ? appointmentCTA.frontQuantity
                                                : appointmentCTA.quantity}
                                    </strong>
                                </label>
                                <select
                                    id="product-qty"
                                    value={this.state.quantity}
                                    onChange={this.handleQuantityChange}
                                    >
                                    {new Array(config.tiresSelectableQty.maxQty)
                                            .fill()
                                            .map((item, i) => {
                                                i++;
                                                return (
                                                    <option value={i} key={i}>
                                                        {i}
                                                    </option>
                                                );
                                            })}
                                </select>
                            </div>
                            <div>
                                {this.props.isStaggered && (
                                <label htmlFor="product-qty">
                                    <strong>{appointmentCTA.rearQuantity}</strong>
                                </label>
                                    )}
                                {this.props.isStaggered && (
                                <select
                                    id="product-qty2"
                                    value={this.state.qty2}
                                    onChange={this.handleRearQuantityChange}
                                        >
                                    {new Array(config.tiresSelectableQty.maxQty)
                                                .fill()
                                                .map((item, i) => {
                                                    i++;
                                                    return (
                                                        <option value={i} key={i}>
                                                            {i}
                                                        </option>
                                                    );
                                                })}
                                </select>
                                    )}
                            </div>
                        </div>
                        <PDPInventoryMsg
                            storeID={this.props.userStore.id}
                            pid={this.props.pid}
                            qty={this.state.quantity}
                            pid2={this.props.pid2}
                            qty2={this.state.qty2}
                            fetchInventoryMsgURL={this.props.fetchInventoryMsgURL}
                            dispatch={this.props.dispatch}
                            inventoryMsg={this.props.inventoryMsg}
                        />
                    </React.Fragment>
                )}
                {this.props.ctaType === 'link' ? (
                    <a
                        aria-label={this.props.ctaLabel}
                        onClick={this.clickHandler}
                        onKeyPress={this.handleKeyPress}
                        className={'js-addItemToCart'}
                        data-url={this.getUrl()}
                    >
                        {this.props.ctaLabel}
                    </a>
                ) : (
                    <button
                        aria-label={this.props.ctaLabel}
                        className={'button js-addItemToCart'}
                        onClick={this.clickHandler}
                        onKeyPress={this.handleKeyPress}
                        data-url={this.getUrl()}
                    >
                        {this.props.ctaLabel}
                    </button>
                )}
            </div>
        );
    }
}

AppointmentCTA.propTypes = AppointmentCTAProps;
AppointmentCTA.defaultProps = {
    appointmentCTADisplayOverride: null
};

export default AppointmentCTA;
